import { ChangeEvent, useState } from "react";
import { Abc, Edit, Phone } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  TextField,
} from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";

import { firestore } from "../..";
import { useAuth } from "../../providers/auth";

export default function AccountUser() {
  const { user } = useAuth();
  const [displayName, setDisplayName] = useState(user?.displayName);
  const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber);
  const [loading, setLoading] = useState(false);
  const [dialog, set] = useState({
    open: false,
    type: "",
    label: "",
    value: "",
  });

  const handleOpen = (type: "name" | "phone") => {
    if (type === "name")
      set({
        open: true,
        type,
        label: "Ditt fullständiga namn",
        value: displayName!,
      });

    if (type === "phone")
      set({
        open: true,
        type,
        label: "Ditt telefon nummer",
        value: phoneNumber!,
      });
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    set({
      ...dialog,
      value: e.target.value,
    });
  };

  const handleSave = async () => {
    setLoading(true);
    const docRef = doc(firestore, "users", user!.uid);

    if (dialog.type === "name") {
      setDisplayName(dialog.value);
      await updateDoc(docRef, { displayName: dialog.value });
    }
    if (dialog.type === "phone") {
      setPhoneNumber(dialog.value);
      await updateDoc(docRef, { phoneNumber: dialog.value });
    }

    setLoading(false);
    handleClose();
  };

  const handleClose = () =>
    set({
      open: false,
      type: "",
      label: "",
      value: "",
    });

  return (
    <>
      <Box mb={2}>
        <List
          subheader={
            <ListSubheader
              disableSticky
              sx={{ backgroundColor: "transparent" }}>
              {user!.email}
            </ListSubheader>
          }>
          <ListItem
            secondaryAction={
              <IconButton
                edge="end"
                aria-label="edit name"
                onClick={() => handleOpen("name")}>
                <Edit />
              </IconButton>
            }>
            <ListItemIcon>
              <Abc />
            </ListItemIcon>
            <ListItemText
              primary={displayName}
              secondary={!displayName && "Ej angett"}
            />
          </ListItem>

          <ListItem
            secondaryAction={
              <IconButton
                edge="end"
                aria-label="edit phone"
                onClick={() => handleOpen("phone")}>
                <Edit />
              </IconButton>
            }>
            <ListItemIcon>
              <Phone />
            </ListItemIcon>
            <ListItemText
              primary={phoneNumber}
              secondary={!phoneNumber && "Ej angett"}
            />
          </ListItem>
        </List>
      </Box>

      <Dialog fullWidth maxWidth="xs" open={dialog.open} onClose={handleClose}>
        <DialogContent>
          <TextField
            autoFocus
            disabled={loading}
            label={dialog.label}
            value={dialog.value}
            onChange={handleChange}
            fullWidth
            variant="standard"
          />

          {loading && <LinearProgress />}
        </DialogContent>
        {!loading && (
          <DialogActions>
            <LinearProgress />
            <Button onClick={handleClose} color="error">
              Avbryt
            </Button>
            <Button onClick={handleSave}>Spara</Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
}
